import { StandardEvents } from '@shopify/events';

let revision = 0;
function renderCount(count) {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-ps-cart-count]').forEach((badge) => {
    badge.textContent = String(count);
    badge.hidden = count === 0;
  });
  document.querySelectorAll('[data-ps-cart-link]').forEach((link) => {
    link.setAttribute('aria-label', `Cart with ${count} ${count === 1 ? 'item' : 'items'}`);
  });
}
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const current = ++revision;
  event.promise?.then(({ cart, detail }) => {
    if (current === revision) renderCount(cart?.totalQuantity ?? detail?.itemCount);
  }).catch(() => { /* The product or cart form presents update failures. */ });
});
window.addEventListener('pageshow', async (event) => {
  if (!event.persisted) return;
  const url = document.querySelector('play-showroom-header')?.dataset.cartJsonUrl;
  if (!url) return;
  const current = ++revision;
  try {
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    if (current === revision) renderCount(cart.item_count);
  } catch { /* Keep the server-rendered count if the request is unavailable. */ }
});
